import ButtonBase from 'components/ui/buttons/button-base';
import React from 'react';

interface Props extends React.HTMLProps<HTMLButtonElement> {
  btnText: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  onClick?: () => void;
  type?: 'button' | 'reset' | 'submit';
  value?: string;
}

/**
 * Button component for text.
 *
 * @param btnText - Contents of the button.
 * @param className - Class name(s) to apply.
 * @param disabled - If true, sets `disabled` property on the button.
 * @param id - The value to set for the `id` property.
 * @param name - The value to set for the `name` property.
 * @param onClick - The callback handler for the click event.
 * @param type - Type property. Must be `button`, `reset`, or `submit`.
 * @param value - Value to set on the button.
 * @param props - Customization options passed to base button.
 * @returns JSX.Element.
 *
 * @example
 *
 * ```typescriptreact
 * <TextButton
 *  btnText={t(
 *    'giving.cta.add_bank_account',
 *    'Add Bank Account',
 *  )}
 *  className="black giving-method left bank"
 *  onClick={() => {
 *    setAddGivingMethodMode('bank')
 *  }}
 * />
 * ```
 */
export function TextButton({ btnText, className, disabled, id, name, onClick, type, value, ...props }: Props) {
  return (
    <ButtonBase
      className={`text-button ${className ?? ''}`}
      disabled={disabled}
      id={id}
      name={name}
      onClick={onClick}
      type={type}
      value={value}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {btnText}
    </ButtonBase>
  );
}
